import { render } from "./DeckFolderModal.vue?vue&type=template&id=3b01205e&scoped=true&ts=true"
import script from "./DeckFolderModal.vue?vue&type=script&lang=ts"
export * from "./DeckFolderModal.vue?vue&type=script&lang=ts"

import "./DeckFolderModal.vue?vue&type=style&index=0&id=3b01205e&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b01205e"]])

export default __exports__